//
// CommentManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var CommentManager = createModule("transport::CommentManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        _getComments_v: [1],
        _addComment_o: [1,1],
        canEdit: [2,1],
        _editComment_o: [1,1],
        supportsObjectLevelComments: [2],
        replyToComment: [1,1,1],
        _editComment_os: [1,1,7],
        isCommentAttachmentDownloaded: [2,1],
        _addComment_os: [1,1,7],
        supportsReportLevelComments: [2],
        _getComments_s: [1,7],
        canDelete: [2,1],
        removeComment: [1,1],
        getCommentAttachment: [1,1],
    },
    ,
    ["getComments","editComment","addComment"],
]);
export default CommentManager;
